import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';
import type { TextProps } from './Typography.types';

const textVariants = cva('', {
  variants: {
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
    },
    weight: {
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
    color: {
      default: 'text-neutral-900 dark:text-neutral-100',
      muted: 'text-neutral-500 dark:text-neutral-400',
      error: 'text-error-600 dark:text-error-400',
      success: 'text-success-600 dark:text-success-400',
      primary: 'text-primary-600 dark:text-primary-400',
    },
    truncate: {
      true: 'truncate',
    },
  },
  defaultVariants: {
    size: 'md',
    weight: 'normal',
    color: 'default',
    truncate: false,
  },
});

export const Text = forwardRef<HTMLParagraphElement, TextProps>(
  (
    { as: Tag = 'p', size, weight, color, truncate, className, ...props },
    ref,
  ) => {
    return (
      <Tag
        ref={ref}
        className={cn(
          textVariants({ size, weight, color, truncate }),
          className,
        )}
        {...props}
      />
    );
  },
);

Text.displayName = 'Text';
